import { Pipe, PipeTransform } from '@angular/core';
import { ArrayManipulations } from '../../../core/utilities/arrayManipulations'

@Pipe({
  name: 'arrayManipulations'
})
export class ArrayManipulationsPipe implements PipeTransform {

  constructor(private arrayManipulations: ArrayManipulations) { }

  transform(value: any, method?: any, args1?: any, args2?: any): any {
    let methodToCall = this.arrayManipulations[method]
    if (Array.isArray(value)) {
      let output = methodToCall(value, args1, args2)
      return output
    }
  }

}
